// extracted by mini-css-extract-plugin
export default {"container":"AttachmentList_container__Ny8OY","images":"AttachmentList_images__mMC4+","files":"AttachmentList_files__hHlqt"};